import { action } from '@/lib/api';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem';
import { store } from '@/redux/lib/configureStore';
import selectors from '@/redux/selectors/selectors';
import { generateObjectSlug } from '@shared/utils/generateObjectSlug';
import { getDeep } from '@shared/utils/getDeep.js';
import { randomId } from '@shared/utils/randomId';
import { setDeep } from '@shared/utils/setDeep.js';

const mockTypeActions = {
  set(path, payload, opts) {
    return new Promise((resolve) => {
      if (!opts?.mockTypeId) {
        console.error('Mock Type ID is required');
        return;
      }

      const state = store.getState();
      const mockType = state.settings.mockDataTypes?.find((mockType) => mockType.id === opts.mockTypeId);
      const newMockType = setDeep(mockType, path, payload);
      const value = getDeep(path, newMockType);

      action('PUT_MOCK_TYPE', { data: [newMockType] });
      pushChangesQueueItem('mockType', { mockTypeId: newMockType?.id, path, value });
      resolve(newMockType);
    });
  },
  create() {
    return new Promise(async (resolve) => {
      const state = store.getState();
      const userId = selectors.userId(state);

      const newMockType = {
        id: randomId(12, 'all'),
        key: generateObjectSlug('unnamed'),
        name: 'Unnamed',
        dataType: 'string',
        createdOn: new Date(),
        createdBy: userId
      };

      action('POST_MOCK_TYPE', { data: [newMockType] });
      pushChangesQueueItem('mockType', { operation: 'add', mockTypeId: newMockType?.id, value: newMockType });
      resolve(newMockType);
    });
  },
  delete(mockTypeId) {
    return new Promise((resolve) => {
      action('DELETE_MOCK_TYPE', { data: { id: mockTypeId } });
      pushChangesQueueItem('mockType', { operation: 'delete', mockTypeId });
      resolve();
    });
  }
};

export default mockTypeActions;
